import { setupCustomCursor } from "@/presentation/prefabs/ui/cursor/cursor.js";
// import { createAudioToggle } from "../k-objects/audioToggle.js"; // For later!
// import { createPauseMenu } from "../k-objects/pauseMenu.js";     // For later!

export function scenesBootstrapper(k) {
    // 1. Boot up the custom mouse
    setupCustomCursor(k);

    // 2. Boot up future global features here...
    // createAudioToggle(k);
    // createPauseMenu(k);
}